import { get } from 'lodash/fp';
import axios from './axios';
import config from '../../helpers/config';
import DesignBuilderPayload from './models/DesignBuilderPayload';

export default ({ estimate, containers, items }) => (
  axios.post(
    config.designBuilderSaveDesignPath,
    new DesignBuilderPayload(estimate, containers, items),
  )
).then(get('data'));
